export default [
  {
    name: 'Decagon',
    // coords: [ [50, 0], [80, 10], [100, 35], [100, 70], [80, 90], [50, 100], [20, 90], [0, 70], [0, 35], [20, 10] ],
    // coords: [ [10, 90], [35, 90], [65, 90], [90, 90], [90, 50], [90, 10], [65, 10], [35, 10], [10, 10], [10, 50] ],
    coords: [ [10, 90], [90, 90], [90, 65], [90, 35], [90, 10], [65, 10], [35, 10], [10, 10], [10, 35], [10, 65] ],
  }
]



// WEBPACK FOOTER //
// ./src/shapes-configuration.js